import * as React from "react"
const SvgBreakLink = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m15.625 12.918-1.775-1.775H15q.424 0 .713.287.287.288.287.713a1 1 0 0 1-.1.45.9.9 0 0 1-.275.325m4.875 9.125a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-17-17a.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275l17 17a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7M7 17.143q-2.075 0-3.538-1.463Q2 14.218 2 12.143q0-1.725 1.05-3.075t2.7-1.775l1.85 1.85H7q-1.25 0-2.125.875A2.9 2.9 0 0 0 4 12.143q0 1.25.875 2.125A2.9 2.9 0 0 0 7 15.143h3q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288zm2-4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.424.287-.713A.97.97 0 0 1 9 11.143h.625l1.975 2zm9.5 2.8a1.05 1.05 0 0 1-.163-.75.88.88 0 0 1 .413-.625q.575-.424.913-1.05.337-.625.337-1.375 0-1.25-.875-2.125A2.9 2.9 0 0 0 17 9.143h-3a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.424.287-.713A.97.97 0 0 1 14 7.143h3q2.075 0 3.538 1.462Q22 10.068 22 12.143a4.8 4.8 0 0 1-.563 2.287 4.96 4.96 0 0 1-1.562 1.763q-.35.225-.75.162a.88.88 0 0 1-.625-.412" />
  </svg>
)
export default SvgBreakLink
